import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';

import Input from 'common/components/form/inputs/Input';
import Textarea from 'common/components/form/inputs/Textarea';
import Select from 'common/components/form/inputs/Select';

const Body = ({ formState }) => {
  const { fields, changeField, selectField } = useFormState(formState);
  const options = [
    { id: 'V', label: 'Voyage' },
    { id: 'T', label: 'TC' }
  ];
  return (
    <div className="edit-cp-form">
      <Row className="no-gutters">
        <Col className="pe-1">
          <Input label="Short Name" onChange={changeField('short_name')} {...fields.short_name} />
        </Col>
        <Col>
          <Input label="Full Name" onChange={changeField('full_name')} {...fields.full_name} />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Textarea
            label="Description"
            onChange={changeField('description')}
            {...fields.description}
          />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Select options={options} label="Type" onChange={selectField('type')} {...fields.type} />
        </Col>
      </Row>
    </div>
  );
};

export default Body;
